import React, { useEffect, useState } from 'react'
import ConnectionComponent from '../../components/ConnectionComponent'
import { Modal, Skeleton, Spin } from 'antd'
import { createApiClient } from '@oneblinktech-org/helios-base';
import ConnectionSteps from '../../components/modals/ConnectionSteps'
import Loader from '../../components/Loader';

const apiUrl = process.env.REACT_APP_API_URL;
const { get } = createApiClient({ apiUrl });

function Connections() {
    const [openConnectionStep, setOpenConnectionStep] = useState(false)
    const [activeConnection, setActiveConnection] = useState(null)
    const [connectionTypes, setConnectionTypes] = useState([])
    const [connectedConnections, setConnectedConnections] = useState([])
    const [isConnected, setIsConnected] = useState(false)
    const [loading, setLoading] = useState(false)
    const [modalWidth, setModalWidth] = useState(502)

    useEffect(() => {
        fetchConnectedConnections()
        fetchConnectionTypes();
    }, []);

    const fetchConnectionTypes = async () => {
        const token = localStorage.getItem('h-access_token');
        setLoading(true)
        try {
            const result = await get('/connectionTypes', {
                "Authorization": `Bearer ` + token
            })
            if (result)
                setConnectionTypes(result);
            setLoading(false)
        } catch (e) {
            console.error('Error fetching connection types:', e);
            setLoading(false)
        }
    };

    const fetchConnectedConnections = async () => {
        const token = localStorage.getItem('h-access_token');
        setLoading(true)
        try {
            const result = await get('/connectionsByOrg', {
                "Authorization": `Bearer ` + token
            })
            if (result)
                setConnectedConnections(result)
            setLoading(false)
        } catch (e) {
            console.error('Error fetching connection types:', e);
            setLoading(false)
        }
    };


    return (
        <div className="connection-container">
            <Loader loading={loading && connectionTypes?.length === 0} />
            <div className="d-flex flex-row justify-content-start align-items-center pb-3">
                <h5 className="heading">Connections</h5>
            </div>
            <div className='connect'>
                <div className='connection-contant' >
                    <b className='label'>Connect Your Apps to Helios</b>
                    <div className='description'>
                        <span>Easily integrate your favorite apps with Helios to enhance your workflow. {<br />}
                            By connecting additional apps, you can streamline tasks, sync data seamlessly, and increase productivity. More integrations will be available soon, so stay tuned for updates!</span>
                    </div>
                </div>


                {loading && connectionTypes?.length === 0 ?
                    <div className='connections' >
                        <div className='connection-card skeleton'>
                            <svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="Vector" d="M14.9919 17H8.64372C6.52897 17 4.72633 16.2201 3.2358 14.6603C1.74527 13.1005 1 11.214 1 9.00097C1 6.7879 1.74527 4.90113 3.2358 3.34068C4.72633 1.78023 6.52897 1 8.64372 1H14.9919V3.644H8.64372C7.22941 3.644 6.02292 4.16661 5.02426 5.21181C4.02561 6.25702 3.52628 7.51975 3.52628 9C3.52628 10.4802 4.02561 11.743 5.02426 12.7882C6.02292 13.8334 7.22941 14.356 8.64372 14.356H14.9919V17ZM10.6842 10.322V7.678H23.3158V10.322H10.6842ZM19.0081 17V14.356H25.3563C26.7706 14.356 27.9771 13.8334 28.9757 12.7882C29.9744 11.743 30.4737 10.4802 30.4737 9C30.4737 7.51975 29.9744 6.25702 28.9757 5.21181C27.9771 4.16661 26.7706 3.644 25.3563 3.644H19.0081V1H25.3563C27.471 1 29.2737 1.7799 30.7642 3.33971C32.2547 4.89952 33 6.78596 33 8.99903C33 11.2121 32.2547 13.0989 30.7642 14.6593C29.2737 16.2198 27.471 17 25.3563 17H19.0081Z" fill="#C4C4C4" stroke="#C4C4C4" stroke-width="0.4" />
                            </svg>
                            <Skeleton active={loading} paragraph={{ rows: 2 }} />
                        </div>
                        <div className='connection-card skeleton'>
                            <svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="Vector" d="M14.9919 17H8.64372C6.52897 17 4.72633 16.2201 3.2358 14.6603C1.74527 13.1005 1 11.214 1 9.00097C1 6.7879 1.74527 4.90113 3.2358 3.34068C4.72633 1.78023 6.52897 1 8.64372 1H14.9919V3.644H8.64372C7.22941 3.644 6.02292 4.16661 5.02426 5.21181C4.02561 6.25702 3.52628 7.51975 3.52628 9C3.52628 10.4802 4.02561 11.743 5.02426 12.7882C6.02292 13.8334 7.22941 14.356 8.64372 14.356H14.9919V17ZM10.6842 10.322V7.678H23.3158V10.322H10.6842ZM19.0081 17V14.356H25.3563C26.7706 14.356 27.9771 13.8334 28.9757 12.7882C29.9744 11.743 30.4737 10.4802 30.4737 9C30.4737 7.51975 29.9744 6.25702 28.9757 5.21181C27.9771 4.16661 26.7706 3.644 25.3563 3.644H19.0081V1H25.3563C27.471 1 29.2737 1.7799 30.7642 3.33971C32.2547 4.89952 33 6.78596 33 8.99903C33 11.2121 32.2547 13.0989 30.7642 14.6593C29.2737 16.2198 27.471 17 25.3563 17H19.0081Z" fill="#C4C4C4" stroke="#C4C4C4" stroke-width="0.4" />
                            </svg>
                            <Skeleton active={loading} paragraph={{ rows: 2 }} />
                        </div>
                    </div>
                    :
                    <Spin spinning={loading}>
                        <div className='connections' >
                            {connectionTypes.map((connection, index) => {
                                return (
                                    <ConnectionComponent
                                        index={index}
                                        connection={connection}
                                        isConnected={connectedConnections?.find((i) => i.type === connection.name)}
                                        setOpenConnectionStep={(open) => {
                                            setIsConnected(connectedConnections?.find((i) => i.type === connection.name))
                                            setOpenConnectionStep(open)
                                        }}
                                        setActiveConnection={setActiveConnection}
                                        key={index}
                                    />
                                )
                            })}
                        </div>
                    </Spin>
                }

                {openConnectionStep &&
                    <Modal closable={false} open={openConnectionStep} footer={null} width={modalWidth} centered key={activeConnection?.id}>
                        <ConnectionSteps
                            connection={activeConnection}
                            closeModal={(isRefresh) => {
                                setOpenConnectionStep(false)
                                if (isRefresh) {
                                    fetchConnectionTypes()
                                    fetchConnectedConnections()
                                }
                            }}
                            connectedConnection={isConnected}
                            setModalWidth={setModalWidth}
                        />
                    </Modal>
                }
            </div>
        </div>
    )
}

export default Connections